import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DataGrid, deDE, GridColDef } from "@mui/x-data-grid";
import React, { useEffect } from "react";
import { useGetUser } from "../../hooks/data/data_profile";
import { IProfile } from "../../interfaces/IUser";

type ProfileAussendienstAssignmentProps = {
    availableAussendienstWorkers: IProfile[];
    assignedAussendienstWorkers: IProfile[];
    handleAssignmentConfirmation: (selectedWorkerIds: number[]) => void;
};

const ProfileAussendienstAssignment: React.FC<ProfileAussendienstAssignmentProps> = ({
    availableAussendienstWorkers,
    handleAssignmentConfirmation,
    assignedAussendienstWorkers,
}) => {
    const { roleArray } = useGetUser();

    const [isOpenAdd, setIsOpenAdd] = React.useState(false);

    const [selectedWorkers, setSelectedWorkers] = React.useState<number[]>(
        assignedAussendienstWorkers.map((worker) => worker.id),
    );

    const columns: GridColDef<IProfile>[] = [
        {
            field: "id",
            headerName: "Nr.",
            valueGetter: (params) => params.row.id,
            width: 70,
        },
        {
            field: "first_name",
            headerName: "Vorname",
            valueGetter: (params) => params.row.User.first_name,
            width: 200,
        },
        {
            field: "last_name",
            headerName: "Name",
            valueGetter: (params) => params.row.User.last_name,
            width: 200,
        },
        {
            field: "email",
            headerName: "Email",
            valueGetter: (params) => params.row.User.email,
            width: 200,
        },
        {
            field: "role",
            headerName: "Rolle",
            valueGetter: (params) => roleArray?.find((role) => role.id === params.row.Role)?.role,
            width: 200,
        },
    ];

    if (!roleArray) {
        return null;
    }

    return (
        roleArray && (
            <>
                <Button onClick={() => setIsOpenAdd(true)} variant="contained">
                    Zugeordnete Aussendienstmitarbeiter verwalten
                </Button>
                <Dialog open={isOpenAdd} onClose={() => setIsOpenAdd(false)} maxWidth="lg" fullWidth>
                    <DialogTitle>Mitarbeiter hinzufügen</DialogTitle>
                    <DialogContent>
                        <DataGrid
                            sx={{ mt: 2 }}
                            autoHeight
                            checkboxSelection
                            localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                            rows={availableAussendienstWorkers}
                            onRowSelectionModelChange={(model) => setSelectedWorkers(model as number[])}
                            rowSelectionModel={selectedWorkers}
                            columns={columns}
                            initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenAdd(false)}>
                            Abbruch
                        </Button>
                        <Button
                            variant="contained"
                            onClick={() => {
                                handleAssignmentConfirmation(selectedWorkers);
                                setIsOpenAdd(false);
                            }}
                        >
                            Bestätigen
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        )
    );
};

export default ProfileAussendienstAssignment;
